import React from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import {
  setConsultationStarted,
  setShowStartConsultationModal,
  updateConsultationButtonStatus,
  updateConsultationStatus,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { PiMicrophone } from "react-icons/pi";
import CustomButton from "../../controls/CustomButton";
import { IoClose } from "react-icons/io5";
import { ActionTrackForConsultations } from "../../../data/actionTrackConsultations";
import { ConsultationButtonStatus } from "../../../enum/ConsultationButtonStatus";
import { setConsultationLoadError } from "../../../dispatchers/appDispatchers";

export default function PatientStartConsultationModal({
  startTranscription,
  stopTranscription,
}) {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    showStartConsultationModal,
    isCallStarted,
    consultationStarted,
    consultationId,
  } = patientState || {};
  const { currentUser, currentPharmacy, company } = appState;

  const closeModal = () => {
    setShowStartConsultationModal(false);
  };
  const handleStart = async () => {
    try {
      startTranscription();
      setConsultationStarted(true);

      await ActionTrackForConsultations(
        0,
        currentUser,
        currentPharmacy,
        company
      );

      closeModal();

      const statusData = {
        consultationId: consultationId,
        actionStatus: 3,
      };
      // await updateConsultationStatus(statusData);
      // const buttonStatusData = {
      //   consultationId: consultationId,
      //   buttonStatus: ConsultationButtonStatus.Pause,
      // };
      // console.log("Updating button status to Pause:", buttonStatusData);
      // await updateConsultationButtonStatus(buttonStatusData);
    } catch (error) {
      console.error("Error in handleStart:", error);
      setConsultationLoadError(true);
    }
  };

  return (
    <Modal
      show={showStartConsultationModal}
      onHide={closeModal}
      centered
      backdrop="static"
      dialogClassName="addNewModal pc-start-modal"
    >
      <div className="header">
        <div>
          <PiMicrophone size={20} color={darkMode ? "#fff" : "#0a0a0a"} />
          <p>Confirm Consultation Start</p>
        </div>
        <IoClose
          size={20}
          color={darkMode ? "#bdbdbd" : "#0a0a0a"}
          onClick={closeModal}
        />
      </div>
      <div className="body">
        <p className="body-info">
          You are about to begin the consultation with the patient. Voice
          recording will start, and their responses will be transcribed and
          analyzed by our AI assistant to support the session.
        </p>
        <p className="mt-2 body-action">Do you want to proceed?</p>
      </div>
      <div className="footer">
        <CustomButton label="No" action={closeModal} />
        <CustomButton label="Yes" action={handleStart} />
      </div>
    </Modal>
  );
}
